import Translations from "../../utils/translations";

class Termin {
    constructor() {
        this._params = {
            json: true
        };
        this.noTermsInfo = $("#no-terms-info");
        this.eventsList = $("#events-list");
        this.eventsDaysList = $("#events-days-list");
        this.t = new Translations();
        this._selectedMonth = null;
    }

    get params() {
        return this._params;
    }

    set params(obj) {
        Object.assign(this._params, obj);
        this.sendAjaxRequest();
    }

    get selectedMonth() {
        return this._selectedMonth;
    }

    set selectedMonth(value) {
        this._selectedMonth = value;
    }

    events() {
        const _this = this;

        $(document).on("calendar:ajax", function (event, params) {
            _this.params = {
                data_od: _this.getDate("from", params.days, params.month, params.year),
                data_do: _this.getDate("to", params.days, params.month, params.year),
                kategoria: params.category
            };

            // Sprawdzanie czy zmienia się miesiąc
            _this.checkIfTheMonthsAreDifferent(params);
        });
    }

    getDate(range, days, month, year) {
        let day = "";
        let zeroMonth = month.length === 1 ? "0" : "";

        if (range === "from") {
            day = days.split("-")[0];
        } else if (range === "to") {
            day = days.split("-")[1];
        }

        let zeroDay = day.length === 1 ? "0" : "";

        return `${year}-${zeroMonth}${month}-${zeroDay}${day}`;
    }

    sendAjaxRequest() {
        const _this = this;

        $.ajax({
            method: "GET",
            url: "/wycieczki/termin.html",
            data: _this.params
        })
            .done(function (response) {
                if (!Array.isArray(response.data)) {
                    _this.noTermsInfo.addClass("d-none");
                    _this.renderEvents(response.data);
                } else {
                    _this.renderEvents();
                    _this.noTermsInfo.removeClass("d-none");
                }
            })
            .fail(function (response) {
                console.error(response);
            });
    }

    getWeekday(date) {
        let year = date.split("-")[0];
        let month = date.split("-")[1].replace(/^[0]/g, "");
        let day = date.split("-")[2].replace(/^[0]/g, "");
        let d = new Date(year, month, day);

        return this.t.get("_" + d.getDay());
    }

    renderEvents(data = "") {
        const _this = this;
        let html = ``;

        function getEventButton(element) {
            html = ``;

            if (element.sprzedazOd.status) {
                html += `<span class="btn btn--large btn--black" style="font-size: 11px;">${
                    element.sprzedazOd.info
                }</span>`;
            } else {
                if (element.dostepnosc.status) {
                    if (element.dostepnosc.ilosc_wolnych_biletow > 0) {
                        html += `<a class="btn btn--brown data-event__button" href="${
                            element.url
                        }">${_this.t.get("_63239ba01c76fbdc81999eb5f3e19835")}</a>`;
                    }
                } else {
                    html += element.dostepnosc.info;
                }
            }

            return html;
        }

        function getAvailabilityOfTickets(element) {
            let html = ``;

            if (element.dostepnosc.status && !element.sprzedazOd.status) {
                if (element.dostepnosc.ilosc_wolnych_biletow === 0) {
                    html += `<div class="data-event__available_tickets">${_this.t.get(
                        "_123d6e65359db3d99e652b69e46628b9"
                    )}</div>`;
                } else {
                    html += `<div class="data-event__available_tickets">${_this.t.get(
                        "_29a8ca34f34be8d3518d6117a232eb7b"
                    )}: ${element.dostepnosc.ilosc_wolnych_biletow}</div>`;
                }
            }

            return html;
        }

        function getEvents(event) {
            html = "";

            event.forEach(function (element, index, array) {
                html += `<div class="data-event__item">
                   <div class="event">
                     <h3><a href="#">${element.nazwa}</a></h3>
                     <time class="data-event__hour" datetime="${element.data} ${
                    element.godzina
                }">${element.godzina}</time>
                   </div>
                   <div class="price data-event__price text-right">
                     ${getEventButton(element)}
                     ${getAvailabilityOfTickets(element)}
                   </div>
                 </div>`;
            });

            return html;
        }

        if (data !== "") {
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    const event = data[key];
                    let year = key.split("-")[0];
                    let month = key.split("-")[1].replace(/^[0]/g, "");
                    let day = key.split("-")[2].replace(/^[0]/g, "");
                    let date = year + "-" + (month - 1) + "-" + day;
                    let weekday = this.getWeekday(date).toLowerCase();

                    html += `<li class="data-event data-day-${day} data-event__tour data-event__tour--delay">
                     <time datetime="${key}">
                       <span class="day">${day}</span>
                       <span class="weekday">${weekday}</span>
                     </time>
                     <div class="data-event__events">${getEvents(event)}</div>
                   </li>`;
                }
            }
        }

        this.eventsList.html(html);
    }

    checkIfTheMonthsAreDifferent(params) {
        let year = params.year;
        let month = params.month;
        let days = params.days;

        if (!this.selectedMonth) {
            this.selectedMonth = month;
            return false;
        }

        if (this.selectedMonth !== month) {
            this.renderMonths(year, month, days);
            this.selectedMonth = month;
        }
    }

    renderMonths(year, month, days) {
        let html = ``;
        let d = new Date(year, month, 0);
        let numberOfDaysInAMonth = d.getDate();

        for (let i = 1; i < numberOfDaysInAMonth + 1; i++) {
            let date = year + "-" + (month - 1) + "-" + i;
            let weekday = this.getWeekday(date).toLowerCase();

            html += `<li data-day="${i}" data-weekday="${weekday}">
                 <span class="drag drag-left"></span>
                 <a href="#" tabindex="-1"><time datetime="">${i}</time></a>
                 <span class="drag drag-right"></span>
               </li>`;
        }

        this.eventsDaysList.html(html);
    }

    init() {
        this.events();
    }
}

export default Termin;
